import IPlanEditor from './IPlanEditor';
import Api from '../../shared/Api';

class PlanEditorsApi {
    static list(): any {
        return new Api().get('/views/planeditors');
    }

    static new(): Promise<any> {
        return new Api().get(`/views/planeditors/new`);
    }

    static create(planEditor: IPlanEditor): Promise<IPlanEditor> {
        return new Api().post('/views/planeditors', planEditor);
    }

    static edit(id: number): Promise<any> {
        return new Api().get(`/views/planeditors/${id}/edit`);
    }

    static update(id: number, input: any): Promise<any> {
        return new Api().put(`/views/planeditors/${id}`, input);
    }

    static delete(id: number) {
        return new Api().delete(`/views/planeditors/${id}`);
    }
}

export default PlanEditorsApi;
